/** Rabattkod för återbokning via kundportalen. */
export const REBOOK_DISCOUNT_CODE = 'EXTRA10';
export const REBOOK_DISCOUNT_PERCENT = 10;
export const REBOOK_DISCOUNT_DISPLAY = 'Extra10';

/** Partnerkampanj Bara GIF. */
export const BARA_GIF_DISCOUNT_CODE = 'BGIF2027';
export const BARA_GIF_DISCOUNT_PERCENT = 15;

const STORAGE_KEY = 'pendingDiscountCode';

export type PendingPromoMeta = {
  code: string;
  percent: number | null;
  label: string;
  /** Kort bannertext med kravformulering om auto i kassan. */
  bannerMessage: string;
};

export function stashPendingDiscountCode(code: string = REBOOK_DISCOUNT_CODE): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, code.trim().toUpperCase());
  } catch {
    // ignore (private mode etc.)
  }
}

export function peekPendingDiscountCode(): string | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw?.trim() ? raw.trim().toUpperCase() : null;
  } catch {
    return null;
  }
}

export function consumePendingDiscountCode(): string | null {
  const code = peekPendingDiscountCode();
  if (!code) return null;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
  return code;
}

/** Metadata för UI när en pending-kod finns i sessionStorage. */
export function getPendingPromoMeta(code?: string | null): PendingPromoMeta | null {
  const resolved = (code ?? peekPendingDiscountCode())?.trim().toUpperCase() || null;
  if (!resolved) return null;

  if (resolved === BARA_GIF_DISCOUNT_CODE) {
    return {
      code: BARA_GIF_DISCOUNT_CODE,
      percent: BARA_GIF_DISCOUNT_PERCENT,
      label: 'Bara GIF-rabatt',
      bannerMessage: `Bara GIF-rabatt aktiverad (${BARA_GIF_DISCOUNT_CODE}). Ordinarie pris visas här — rabatten appliceras automatiskt i sista steget i kassan.`,
    };
  }

  if (resolved === REBOOK_DISCOUNT_CODE) {
    return {
      code: REBOOK_DISCOUNT_CODE,
      percent: REBOOK_DISCOUNT_PERCENT,
      label: 'Stamkundserbjudande',
      bannerMessage: `Stamkundserbjudande: koden ${REBOOK_DISCOUNT_DISPLAY} ger ${REBOOK_DISCOUNT_PERCENT}% rabatt — den appliceras automatiskt i sista steget i kassan.`,
    };
  }

  return {
    code: resolved,
    percent: null,
    label: 'Rabattkod',
    bannerMessage: `Rabattkod ${resolved} är sparad — rabatten appliceras automatiskt i sista steget i kassan. Ordinarie pris visas på produktsidor.`,
  };
}
